import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
import store from "./store/index"
import { sync } from 'vuex-router-sync'
import firebase from 'firebase'
import 'firebase/firestore'
import VuetifyConfirm from 'vuetify-confirm'
import VueCookies from 'vue-cookies'
import VueYoutube from 'vue-youtube'
import VueSweetalert2 from 'vue-sweetalert2';
import VueFilterNumericFormat from '@vuejs-community/vue-filter-numeric-format';
import VueHtmlToPaper from 'vue-html-to-paper';
import { required, email, max, min, size } from 'vee-validate/dist/rules'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from 'vee-validate'
import DatetimePicker from 'vuetify-datetime-picker'
const fb = require('./firebaseConfig.js')


Vue.config.productionTip = false

Vue.use(require('vue-moment'))
Vue.use(VuetifyConfirm, { vuetify })
Vue.use(VueCookies)
Vue.use(VueYoutube)
Vue.use(VueSweetalert2);
Vue.use(VueFilterNumericFormat, {
  decimalSeparator: '.', fractionDigitsMax: 0,
  fractionDigitsMin: 0,
  fractionDigitsSeparator: '',
  thousandsDigitsSeparator: ','
});


Vue.use(DatetimePicker)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VueHtmlToPaper, {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
});


extend('required', {
  ...required,
  message: 'Enter {_field_}'
})

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters'
})

extend('min', {
  ...min,
  message: '{_field_} may not be less than {length} characters'
})

extend('email', {
  ...email,
  message: 'Email must be valid'
})

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target
  },
  message: 'Password does not match'
})

extend('size', {
  ...size,
  message: 'video size should be less than 5 MB!'
})


sync(store, router)

firebase.auth().onAuthStateChanged(async user => {
  if (user) {
    console.log(user)
    var doc = await fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/employees")
      .where("email", "==", user.email)
      .limit(1)
      .get();
    if (doc.empty) {
      doc = await fb.db
        .collection("/schools/YJHjHWUGDok8teDhDIKX/students")
        .where("email", "==", user.email)
        .limit(1)
        .get();
    }
    console.log(doc)
    if (!doc.empty) {
      var userObj = doc.docs[0];
      if (userObj.exists) {
        let userData = userObj.data();
        userData.id = userObj.id;
        userData.ref = userObj.ref;
        if (userData.ref.parent.parent) {
          userData.ppschool = userData.ref.parent.parent.path
          await userData.ref.parent.parent.get().then((doc) => {
            userData.school = doc.data()
            userData.school.ref = doc.ref
          })
        } else userData.ppschool = null
        console.log(userData.ppschool)

        store.state.userProfile = userData
        console.log(store.state.userProfile)
      }
    }
  } else {
    //store.dispatch('clearData')
  }
  new Vue({
    store,
    router,
    vuetify,
    render: h => h(App),
  }).$mount('#app')

})

Vue.$cookies.config('7d')
// Vue.config.productionTip = false
